import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';

// Globals
import { GlobalsService } from './globals.service';

@Injectable({
  providedIn: 'root'
})
export class ViasAuthLogoutService implements CanActivate {

  constructor(private globals: GlobalsService, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    this.globals.logout();
    return true;
  }
}
